import { API_URL_PROD, API_URL_TEST, EXP_URL_PROD, EXP_URL_TEST } from '../constants';
import { IsLocalHost, IsStaging } from '../utils/enviroment';

export const getApiUrl = () => {

    if (IsLocalHost() || IsStaging()) return API_URL_TEST;

    return API_URL_PROD;
};

export const getExpUrl = () => {

    if (IsLocalHost() || IsStaging()) return EXP_URL_TEST;

    return EXP_URL_PROD;
}
